import { render, staticRenderFns } from "./recentList.vue?vue&type=template&id=15e1b0c0&scoped=true"
import script from "./recentList.vue?vue&type=script&setup=true&lang=js"
export * from "./recentList.vue?vue&type=script&setup=true&lang=js"
import style0 from "./recentList.vue?vue&type=style&index=0&id=15e1b0c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e1b0c0",
  null
  
)

export default component.exports